import { render, staticRenderFns } from "./pianifica.vue?vue&type=template&id=c86f05ec&scoped=true&"
import script from "./pianifica.vue?vue&type=script&lang=js&"
export * from "./pianifica.vue?vue&type=script&lang=js&"
import style0 from "./pianifica.vue?vue&type=style&index=0&id=c86f05ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86f05ec",
  null
  
)

export default component.exports